import * as React from "react";
import get from "lodash/get";

import "./ErrorMessage.css";
import { onClickSendToMerchant } from "../../utils/sendClickToMerchant";
import { WidgetProps } from "../Widget/Widget";
import { getHorizontalAlignment } from "../../utils/getHorizontalAlignment";

export interface ErrorMessageProps extends WidgetProps {
  content: string;
  errorMessage: string;
  name: string;
}

export class ErrorMessage extends React.Component<ErrorMessageProps> {
  component: HTMLSpanElement | null;

  componentDidMount() {
    if (this.component && this.props.horizontalAlign) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  componentDidUpdate(prevProps: ErrorMessageProps) {
    if (
      this.component &&
      prevProps.horizontalAlign !== this.props.horizontalAlign
    ) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  render() {
    const { style, errorMessage, configName, config } = this.props;
    const errorStr = config.__editMode__
      ? "example error message"
      : errorMessage;

    if (!errorStr) {
      return null;
    }

    return (
      <span
        id={this.props.configName}
        onClick={onClickSendToMerchant(configName)}
        style={style}
        className="ErrorMessage-container"
        aria-label={get(this.props, "label", "")}
        ref={(component) => (this.component = component)}
      >
        {this.props.content ? this.props.content : errorStr}
      </span>
    );
  }
}
